import { AutoCoderVariable } from '../../../types/gotypes'

export const BUILTIN_SENTIMENT: AutoCoderVariable = {
  name: 'sentiment',
  codes: [
    { code: '-100', text: 'Negative' },
    { code: '0', text: 'Neutral' },
    { code: '100', text: 'Positive' },
  ],
}

export const BUILTIN_EMOTION: AutoCoderVariable = {
  name: 'emotion',
  codes: [
    { code: 'trust', text: 'trust' },
    { code: 'fear', text: 'fear' },
    { code: 'surprise', text: 'surprise' },
    { code: 'sadness', text: 'sadness' },
    { code: 'disgust', text: 'disgust' },
    { code: 'anger', text: 'anger' },
    { code: 'anticipation', text: 'anticipation' },
    { code: 'joy', text: 'joy' },
  ],
}

export const DEFAULT_LOOPED_VARIABLES: AutoCoderVariable[] = [
  BUILTIN_SENTIMENT,
  BUILTIN_EMOTION,
]
